import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { NAV } from "../data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "glass border-b border-black/10 py-4" : "border-b border-transparent py-6"
      }`}
      data-testid="site-header"
    >
      <div className="container-vx flex items-center justify-between">
        <a href="#top" className="flex items-center group" data-testid="logo-link" aria-label="Vertex Automation home">
          <img
            src="/vertex-logo.png"
            alt="Vertex Automation"
            className="h-10 w-auto object-contain transition-transform duration-500 group-hover:scale-[1.04] md:h-11"
          />
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="group relative font-body text-sm text-neutral-600 transition-colors hover:text-black"
            >
              {n.label}
              <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-black transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="header-cta"
            className="group hidden items-center gap-2 rounded-full bg-black px-5 py-2.5 font-body text-sm font-medium text-white transition-transform duration-300 hover:scale-[1.03] md:inline-flex"
          >
            Book a Demo
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/15 text-black md:hidden"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="glass border-t border-black/10 md:hidden"
          data-testid="mobile-menu"
        >
          <div className="container-vx flex flex-col gap-1 py-6">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="border-b border-black/5 py-3 font-sans text-lg text-neutral-800"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center rounded-full bg-black py-3 font-medium text-white"
            >
              Book a Demo
            </a>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};
